import { Input, Select } from '../../../../shared/components/FormControls';
import Rodal from 'rodal';
import { Button } from '../../../../shared/components/Button';
import '../../../../shared/styles/Orchestrator.css';
import 'rodal/lib/rodal.css';
import { useEffect, useState } from 'react';

const EFFECT_OPTIONS = [
  { value: 'fog', label: 'Fog', color: '#9fb3c8' },
  { value: 'ice', label: 'Ice', color: '#9ad8ff' },
  { value: 'fire', label: 'Fire', color: '#ffb38a' },
  { value: 'acid', label: 'Acid', color: '#b6e673' },
];

const SHAPE_OPTIONS = [
  { value: '', label: 'Manual (paint)' },
  { value: 'line_h', label: 'Line (horizontal, both ways)' },
  { value: 'line_v', label: 'Line (vertical, both ways)' },
  { value: 'line_n', label: 'Line North' },
  { value: 'line_s', label: 'Line South' },
  { value: 'line_e', label: 'Line East' },
  { value: 'line_w', label: 'Line West' },
  { value: 'line_ne', label: 'Line NE' },
  { value: 'line_nw', label: 'Line NW' },
  { value: 'line_se', label: 'Line SE' },
  { value: 'line_sw', label: 'Line SW' },
  { value: 'cone_right', label: 'Cone Right' },
  { value: 'cone_left', label: 'Cone Left' },
  { value: 'cone_up', label: 'Cone Up' },
  { value: 'cone_down', label: 'Cone Down' },
  { value: 'circle', label: 'Circle' },
  { value: 'square', label: 'Square' },
];

function BattleEffectModal({ visible, form, onChange, onCancel, onSave, mode = 'light' }) {
  const isDark = mode === 'dark';
  const [isPhone, setIsPhone] = useState(false);

  useEffect(() => {
    const mediaQueryWidth = window.matchMedia('(max-width: 620px)');
    const handleMediaChange = () => {
      setIsPhone(mediaQueryWidth.matches);
    };
    handleMediaChange();
    mediaQueryWidth.addListener(handleMediaChange);
    return () => {
      mediaQueryWidth.removeListener(handleMediaChange);
    };
  }, []);

  const hasShape = !!form.shape;

  return (
    <Rodal
      animation='slideUp'
      visible={visible}
      onClose={onCancel}
      className={isDark ? 'df_rodal_dark' : ''}
      customStyles={{
        border: isDark ? '2px solid var(--onyx)' : '2px solid #e4E7C5',
        backgroundColor: isDark ? 'var(--jet)' : '#f6f7eb',
        color: isDark ? 'var(--ivory)' : 'var(--jet)',
        width: isPhone ? 'calc(100% - 34px)' : '420px',
        height: isPhone ? 'calc(100% - 114px)' : '450px',
        marginTop: isPhone ? '80px' : '',
      }}
    >
      <div
        className={`trialment_login_form ${isDark ? 'df_modal_form_dark' : ''}`}
        style={{ display: 'flex', flexDirection: 'column', height: '100%' }}
      >
        <div style={{ flex: 1, overflowY: isPhone ? 'auto' : 'visible' }}>
          <div
            className='trialment_login_form_row'
            style={{ fontWeight: 700, fontSize: 16, marginBottom: 6, textAlign: 'center' }}
          >
            Battle Effect
          </div>
          <div className='trialment_login_form_row'>
            <Input
              type='text'
              placeholder='Effect name'
              value={form.name}
              onChange={(event) => onChange({ name: event.target.value })}
            />
          </div>
          <div className='trialment_login_form_row'>
            <Input
              type='text'
              placeholder='Group'
              value={form.group || ''}
              onChange={(event) => onChange({ group: event.target.value })}
            />
          </div>
          <div
            className='trialment_login_form_row'
            style={{ display: 'flex', gap: 12, width: '100%' }}
          >
            <label
              style={{ display: 'flex', flexDirection: 'column', gap: 6, flex: 1 }}
            >
              <span style={{ fontWeight: 700, fontSize: 12 }}>Type</span>
              <Select
                value={form.kind}
                onChange={(event) => onChange({ kind: event.target.value })}
                style={{ width: '200px', maxWidth: '100%', fontSize: '14px' }}
              >
                {EFFECT_OPTIONS.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </Select>
            </label>
            <label
              style={{ display: 'flex', flexDirection: 'column', gap: 6, flex: 1 }}
            >
              <span style={{ fontWeight: 700, fontSize: 12 }}>Color</span>
              <div style={{ display: 'flex', gap: 6, alignItems: 'center', width: '200px', maxWidth: '100%' }}>
                <Input
                  type='color'
                  value={form.color || '#9fb3c8'}
                  onChange={(event) => onChange({ color: event.target.value })}
                />
                <Input
                  type='text'
                  value={form.color || '#9fb3c8'}
                  onChange={(event) => onChange({ color: event.target.value })}
                  style={{ flex: 1, minWidth: 0, fontSize: '14px' }}
                  placeholder='#9fb3c8'
                />
              </div>
            </label>
          </div>
          <div
            className='trialment_login_form_row'
            style={{ display: 'flex', gap: 12, width: '100%' }}
          >
            <label
              style={{ display: 'flex', flexDirection: 'column', gap: 6, flex: 1 }}
            >
              <span style={{ fontWeight: 700, fontSize: 12 }}>Shape</span>
              <Select
                value={form.shape || ''}
                onChange={(event) => onChange({ shape: event.target.value })}
                style={{ width: '200px', maxWidth: '100%', fontSize: '14px' }}
              >
                {SHAPE_OPTIONS.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </Select>
            </label>
            <label
              style={{ display: 'flex', flexDirection: 'column', gap: 6, flex: 1 }}
            >
              <span style={{ fontWeight: 700, fontSize: 12 }}>Size</span>
              <Input
                type='number'
                min='1'
                max='10'
                step='1'
                value={form.size ?? 3}
                disabled={!hasShape}
                onChange={(event) => onChange({ size: Number(event.target.value) })}
                style={{ width: '200px', maxWidth: '100%', fontSize: '14px' }}
              />
            </label>
          </div>
          <div
            className='trialment_login_form_row'
            style={{ display: 'flex', gap: 12, width: '100%' }}
          >
            <label
              style={{
                display: 'flex',
                flexDirection: 'column',
                gap: 6,
                width: '100%',
                maxWidth: '250px',
                alignItems: 'center',
              }}
            >
              <span style={{ fontWeight: 700, fontSize: 12, textAlign: 'center' }}>
                Opacity ({Math.round((form.opacity || 0) * 100)}%)
              </span>
              <Input
                type='range'
                className='battle_effect_opacity_slider'
                variant='cinnabar'
                min='0.1'
                max='0.8'
                step='0.05'
                value={form.opacity ?? 0.4}
                onChange={(event) => onChange({ opacity: Number(event.target.value) })}
                style={{
                  width: '100%',
                  maxWidth: '100%',
                  '--battle-effect-thumb-background': isDark
                    ? 'var(--jet)'
                    : '#f6f7eb',
                }}
              />
            </label>
          </div>
          <div
            className='trialment_login_form_row'
            style={{
              fontSize: '12px',
              color: isDark ? 'rgba(246, 247, 235, 0.75)' : '#555',
            }}
          >
            Battle Effect spawn from the selected Token
          </div>
        </div>
        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            gap: '10px',
            marginTop: '8px',
            marginBottom: '8px',
          }}
        >
          <Button label='Cancel' type={mode === 'dark' ? 'onyx' : 'black-white'} onPress={onCancel} />
          <Button label='Save' type='cinnabar' onPress={onSave} />
        </div>
      </div>
    </Rodal>
  );
}

export default BattleEffectModal;
